<template>
  <div :style="mainStyle">
    <section class="price-dialog-wrap" v-if="showPriceDialog">
      <!-- <div class="content">
        <header>
          <h2>以下工具推荐在Windows10及以上操作系统中运行</h2>
          <span class="close" @click="showPriceDialog = false"></span>
        </header>
        <div class="table-wrap">
          <span v-if="!isWin" class="sys-tip"
            >当前不是Windows的PC环境，客户端可能无法使用</span
          >
          <span class="open-style" @click="openZip"
            >客户端zip压缩包的打开方式</span
          >
          <div class="table-inner-wrap">
            <div class="table-head">
              <span>&nbsp;&nbsp;&nbsp;大数据工具名称</span>
              <span>功能</span>
              <span>范围/频度</span>
              <span>&nbsp;&nbsp;价格</span>
              <span>点击下载客户端 </span>
            </div>
            <div class="table-content">
              <div
                class="table-row"
                v-for="item in price_dialog_content"
                :key="item"
              >
                <div class="cell">
                  <span style="font-size: 18px"> {{ item[0] }} </span> <br />
                  <span style="font-size: 16px"> {{ item[1] }} </span>
                </div>
                <div class="cell">
                  <span> {{ item[2] }}</span>
                </div>
                <div class="cell">
                  <span> {{ item[3] }}</span>
                </div>
                <div class="cell">
                  <span style="color:#2C2C2C;"> {{ item[4] }}</span>
                  <br />
                  <span> {{ item[5] }}</span>
                </div>
                <div class="cell download">
                  <a
                    :href="
                      'https://www.daasmart.com/software/win/' +
                        item[6] +
                        '.zip'
                    "
                    :download="item[6] + '.zip'"
                    >下载</a
                  >
                  <span> {{ item[7] }} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="table-outter">
        <header>
          <h2>产业招商数据大脑</h2>
          <span class="close" @click="showPriceDialog = false"></span>
        </header>

        <section class="table-info">
          <div class="table-inner">
            <ul>
              <li v-for="item in currentTableInfo" :key="item.desc">
                <p>
                  <span> {{ item.title.split("-")[0] }} </span> <br />
                  <span> {{ "-" + item.title.split("-")[1] }}</span>
                </p>
                <span class="aspan">{{ item.desc }} </span>
              </li>
            </ul>
          </div>
          <div class="table-detail">
            <p>
              支持全部7600万家企业， 支持全部2861个区县和全部337个城市，每周更新
            </p>
            <p>
              试用和购买请联系客户经理，支持定制
            </p>
            <a
              class="zip"
              href="https://www.daasmart.com/software/win/BRAINS.zip"
              download="BRAINS.zip"
              >下载（BRAINS.zip）</a
            >
            <p>推荐在Windows10及以上操作系统中运行</p>
            <span @click="openZip" class="zip">如何打开zip文件？</span>
          </div>
        </section>
      </div>
    </section>
    <!--文档-->
    <pannel-widget v-model="doc.visible" v-bind="doc.pannel_data">
      <div class="flex-column pcenter pad-1 max color-light">
        <h5 class="fsize-1d3 pad-t-1">{{ doc.title }}</h5>
        <div class="flex-2 mrg-t-2 mrg-b-1">
          <btn-widget @on_click="$_exit_doc" btn-text="退出文档" />
        </div>
        <hr />
        <div class="pleft auto-scroll" ref="docCont">
          <article v-html="doc.desc"></article>

          <!--表格数据-->
          <table-widget
            v-if="doc.cont.type === 'table'"
            v-bind="doc.cont.info"
          />
        </div>
      </div>
    </pannel-widget>

    <!--软件下载表单-->
    <section class="fsize-1d2">
      <form-pannel-widget
        v-model="download_form.pannel_info"
        :pannel-title="download_form.pannel_title"
        :pannel-data="download_form.pannel_data"
        :form-data="download_form.form_data"
      />
    </section>

    <!--navs-->
    <response-nav-widget :header-nav-data="main_nav" />

    <!--banner-->
    <section
      id="main"
      :style="
        `background-image: url(${require('@/assets/img/backgrounds/img-41.jpg')})`
      "
      class="bg-size-cover"
    >
      <div class="rel pcenter color-light pad-v-8 pad-v-5-s">
        <div class="bg-color-blue alpha-d8 max abs z0 t-0"></div>
        <div class="rel z1 pad-h-8 pad-h-2-s">
          <img
            :src="require('@/assets/img/logo/icon.png')"
            class="h-3 scale-d8-s"
          />
          <h2 class="fsize-3d5 mrg-v-d5 fsize-2d5-s">实时数据库</h2>
          <h3 class="fsize-1d5">互联网感知的、中国GIS宏观数据的神经系统</h3>
          <article
            class="container mrg-t-4 fsize-1d3 alpha-d8 pjustify-s fsize-1d2-s"
            md
          >
            <div style="text-indent:34px">
              DaaS是清华大学信息研究院“智库2861”项目组发布的数据库，它的第一部分由三千余个独立的数据库构成，一一对应我国全部2861个行政区县、330个地市、31个省和直辖市。它的第二部分是由细化到1平方公里的980万个网格构成的数据库。它的第三部分是由涵盖我国全部产业类型的产业风险数据库构成，共收录全国市场主体209,493,723家，包含注册企业76,734,176家、个体工商户126,131,418家和未知类型公司6,628,129家。它的第四部分是来自遥感卫星的实时数据，7*24更新。它的输出数据，不是互联网上的真假难辨的“数据“，而是由AI算法产生的、客观实时数据。数据库每天更新。数据的含金量超过普通的网络数据，适合应用到宏观和商业应用中。适合政府、智库、高校、金融领域的长周期分析。
              <br />
              <a
                target="_blank"
                href="https://2861.wiki/1017/riit.html"
                class="underline"
                >更多信息，请联系清华“智库2861”项目组</a
              >
              <!-- <a
                target="_blank"
                href="https://www.riit.tsinghua.edu.cn/info/1017/4946.htm"
                class="underline"
                >更多信息，请联系清华“智库2861”项目组</a
              > -->
              。
            </div>
          </article>
          <div class="flex-2 mrg-t-4 hide-s">
            <div>
              <!-- <b-hot
                styles="flex-2 color-light fsize-1.7 pad-v-1 w-27 trans-fast round-sm bg-color-rgba(2,185,161,.5) mrg-b-2"
                hover="bg-color-rgba(2,185,161,.8)"
                @on_click="$_download_zk2861_pro"
              >
                了解和使用产业、招商工具库
              </b-hot> -->
              <!-- <a
                class="fsize-1d2 line-b line-mgray thick-1"
                href="/static/pro_book.pdf"
                download="DaaS数据库使用说明.pdf"
                >下载 DaaS 数据库使用说明</a
              > -->
            </div>
          </div>
          <!-- <div class="alpha-d6 mrg-t-3">
            使用产品有任何疑问请联系清华智库2861项目组<br />
            或拨打：400-833-2861<br />我们也会通过以上手机或者邮箱联系您，了解使用产品的情况，谢谢反馈。
          </div> -->
          <div class="fsize-1d4 mrg-t-3 hide show-s">
            请于 PC 端进行数据库下载
          </div>
        </div>
      </div>
    </section>

    <!--daas 数据包介绍-->
    <section
      id="aboutDaas"
      class="rel color-light bg-size-cover"
      :style="
        `background-image: url(${require('@/assets/img/backgrounds/img-37.jpg')})`
      "
    >
      <div class="abs max bg-color-main alpha-d9"></div>
      <div class="rel z1 container pad-t-5 pad-b-4 pcenter pad-h-1">
        <h2 class="mrg-b-3">
          <span class="fsize-1d5 fsize-1d3-s">DaaS 数据包介绍</span>
        </h2>
        <div class="container fsize-1d3" sm>
          <tab-widget
            v-if="daas_data"
            v-bind="daas_data.tab_data"
            v-model="daas_data.cur_tab"
          >
            <div
              class="rel l-f1px resize"
              :slot="item.id"
              v-for="item of daas_data.tab_data.tagsData.tagList"
              :key="item.id"
            >
              <!--数据包概览-->
              <ul
                v-if="daas_data.content[item.id].type === 'intro'"
                class="
									grid
									bg-color-sub
									round-sm
									pad-h-d5 pad-v-1
									fsize-1d1 fsize-d9-s
								"
              >
                <li
                  v-for="(item, i) of daas_data.content[item.id].data"
                  :key="i"
                  class="col-4 pad-d5 col-6-s"
                >
                  <b-hot
                    styles="flex-column round-sm bg-color-rgba(255,255,255,.7)"
                    hover="bg-color-rgba(255,255,255,.4)"
                    :link="`/${item.id}`"
                  >
                    <div class="flex-between pad-1">
                      <img
                        :src="
                          require(`@/assets/img/daas_case/${item.id}_cover.jpg`)
                        "
                        class="round-sm w-4 h-4 w-3-s h-3-s"
                      />
                      <img
                        :src="require(`@/assets/img/products/${item.id}.png`)"
                        class="round-sm w-7 h-7"
                      />
                    </div>
                    <div
                      class="
												pad-d5
												color-dgray
												line-t line-neutral
												thick-1
												ellipsis
											"
                    >
                      {{ item.text }}
                    </div>
                  </b-hot>
                </li>
              </ul>

              <!--表格数据-->
              <table-widget v-else v-bind="daas_data.content[item.id]" />
            </div>
          </tab-widget>
        </div>
      </div>
    </section>

    <!--基于DaaS的应用-->
    <section id="daasCase" class="bg-color-lgray">
      <div class="container pad-t-4 pad-b-6 pcenter pad-h-2">
        <h2><span class="fsize-1d5 fsize-1d3-s">基于 DaaS 的应用</span></h2>
        <ul class="grid mrg-t-2 fsize-1d4 bold">
          <!--估房 go-->
          <li class="col-4 pad-1 col-12-s">
            <b-hot
              styles="flex-column round-md shadow bg-color-light color-neutral pad-v-1.5 trans-fast"
              link="https://house.2861.wiki/"
              hover="color-mgray scale-1.04"
            >
              <div>
                <img
                  :src="require('@/assets/img/logo/go_logo.png')"
                  class="h-4 mrg-b-1 scale-d8-s"
                />
              </div>
              <div class="color-dgray">地产数据库估房 go</div>
            </b-hot>
          </li>

          <!--2861/1-->
          <li class="col-4 pad-1 col-12-s">
            <b-hot
              styles="flex-column round-md shadow bg-color-main color-neutral pad-v-1.5 trans-fast"
              link="/"
              hover="color-mgray scale-1.04"
            >
              <div>
                <img
                  :src="require('@/assets/img/logo/2861_logo.png')"
                  class="h-4 mrg-b-1 scale-d8-s"
                />
              </div>
              <div class="color-lgray">区县社会感知大数据决策辅助系统</div>
            </b-hot>
          </li>

          <!--地理网格-->
          <li class="col-4 pad-1 col-12-s">
            <b-hot
              styles="flex-column round-md shadow bg-color-dblue color-neutral pad-v-1.5 trans-fast"
              link="https://big-grid.2861.wiki/"
              hover="color-mgray scale-1.04"
            >
              <div>
                <img
                  :src="require('@/assets/img/logo/gen_logo.png')"
                  class="h-4 mrg-b-1 scale-d8-s"
                />
              </div>
              <div class="color-mgray">地理网格大数据平台</div>
            </b-hot>
          </li>
        </ul>
      </div>
    </section>

    <!--产品下载-->
    <section id="pros">
      <div class="container pad-t-4 pad-b-6 pcenter pad-h-2">
        <h2><span class="fsize-1d5 fsize-1d3-s">产品下载</span></h2>
        <div class="alpha-d7 fsize-1d3 pad-v-1">
          (仅在 windows 平台电脑 (pc) 端下载和使用)
        </div>
        <article class="container fsize-1d3 pad-t-1 fsize-1d2-s pjustify-s" md>
          大数据驱动新型智库等系列区域性智慧大脑综合应用，以区域治理和增长点为突破口，通过全覆盖、细粒度、强实时、超高速、高可信的大数据处理、分析和挖掘，探索基于互联网感知的民生民情各项指标的内在规律，及其与各地社会经济发展的关键指标之间的关系，如人口、经济、收入、GDP、人均GDP等数据耦合关系与规律。
        </article>
        <div class="alpha-d7 mrg-t-3">
          使用产品有任何疑问请联系清华智库2861项目组<br />
          或拨打：400-833-2861<br />我们也会通过以上手机或者邮箱联系您，了解使用产品的情况，谢谢反馈。
        </div>
        <div class="hide-s pad-t-3">
          <div class="flex-2 mrg-b-1">
            <div>
              <a
                class="item-widget flex-2 trans"
                href="javascript:;"
                @click="$_download_zk2861_pro"
              >
                <img
                  :src="require('@/assets/img/products/d6.png')"
                  class="flex scale-d7-s"
                />
              </a>
              <br />
              <!-- <a
                class="fsize-1d2 line-b line-mgray thick-1"
                href="/static/pro_book.pdf"
                download="DaaS数据库使用说明.pdf"
                >下载 DaaS 数据库使用说明</a
              > -->
            </div>
          </div>
          <div class="line-b thick-1 color-neutral mrg-b-3">
            <span class="rel triangle-t color-mgray"></span>
          </div>
          <div class="grid">
            <div class="col-2d4 pad-h-d5 flex-2 col-6-s mrg-b-1-s">
              <a
                class="d1 item-widget trans"
                href="javascript:;"
                @click="$_show_download_pannel('hqd')"
              >
                <img
                  :src="require('@/assets/img/products/d1.png')"
                  class="flex"
                  style="width: 100%"
                />
              </a>
            </div>
            <div class="col-2d4 pad-h-d5 flex-2 col-6-s mrg-b-1-s">
              <a
                class="d2 item-widget trans"
                href="javascript:;"
                @click="$_show_download_pannel('cty')"
              >
                <img
                  :src="require('@/assets/img/products/d2.png')"
                  class="flex"
                  style="width: 100%"
                />
              </a>
            </div>
            <div class="col-2d4 pad-h-d5 flex-2 col-6-s mrg-b-1-s">
              <a
                class="d3 item-widget trans"
                href="javascript:;"
                @click="$_show_download_pannel('download')"
              >
                <img
                  :src="require('@/assets/img/products/d3.png')"
                  class="flex"
                  style="width: 100%"
                />
              </a>
            </div>
            <div class="col-2d4 pad-h-d5 flex-2 col-6-s mrg-b-1-s">
              <a
                class="d4 item-widget trans"
                href="javascript:;"
                @click="$_show_download_pannel('mong')"
              >
                <img
                  :src="require('@/assets/img/products/d4.png')"
                  class="flex"
                  style="width: 100%"
                />
              </a>
            </div>
            <div class="col-2d4 pad-h-d5 flex-2 col-6-s mrg-b-1-s">
              <a
                class="d5 item-widget trans"
                href="javascript:;"
                @click="$_show_download_pannel('real_estate')"
              >
                <img
                  :src="require('@/assets/img/products/d5.png')"
                  class="flex"
                  style="width: 100%"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--年费会员用户的优惠内容-->
    <section
      :style="
        `background-image: url(${require('@/assets/img/backgrounds/img-36.jpg')})`
      "
      class="bg-color-gray"
    >
      <div class="container pcenter pad-v-5 pad-h-2 pad-h-1-s">
        <h2>
          <span class="fsize-1d5 fsize-1-s"
            >如有下载数据的需求，请联系项目组</span
          >
        </h2>
        <div class="fsize-1d7 mrg-t-4 alpha-d8">
          <div>
            联系电话：<span class="color-main fsize-1d4">400-833-2861</span>
          </div>
        </div>
      </div>
    </section>

    <!--付费用户-->
    <section id="cases">
      <div class="container pad-t-5 pad-b-4 pcenter pad-h-2 pad-h-1-s">
        <h2><span class="fsize-1d5 fsize-1d3-s">付费用户</span></h2>
        <article
          class="
						container
						fsize-1d3
						pad-t-1 pad-b-4
						fsize-1d2-s
						pjustify-s
						pad-h-1-s
					"
          md
        >
          DaaS以其全域覆盖、无干预智能处理、24小时动态增长等优势特性，可广泛助力于商业、公管、研究和学术领域。
        </article>

        <!--pc 端适配-->
        <div class="hide-s">
          <b-grid :col-data="cases" :line="['lgray', 1]" outline-color="#fff">
            <b-hot
              v-for="(item, index) of cases.items"
              :slot="item.id"
              :key="item.id"
              styles="rel flex-column h-17"
              @on_enter="$_show_detail(index)"
              @on_leave="$_hide_detail(index)"
            >
              <div class="pad-1d5">
                <img
                  :src="require(`@/assets/img/case/${item.img}.jpg`)"
                  class="h-6"
                />
                <div class="fsize-1d3 mrg-v-1">
                  <b>{{ item.user }}</b>
                </div>
                <div>{{ item.pro_name }}</div>
              </div>
              <div
                :class="
                  `trans-fast abs max bg-color-lgray t-0 l-0 ${
                    item.show ? 'alpha-d9' : 'alpha-0'
                  }`
                "
              >
                <article
                  class="color-dark abs max fsize-1d1 pleft pad-2 auto-scroll"
                >
                  {{ item.desc }}
                </article>
              </div>
            </b-hot>
          </b-grid>
        </div>

        <!--mob 端适配-->
        <div class="hide show-s">
          <b-grid :col-data="cases" :line="['lgray', 1]" outline-color="#fff">
            <b-hot
              v-for="(item, index) of cases.items"
              :slot="item.id"
              :key="item.id"
              styles="rel flex-column h-17"
              @on_click="$_show_detail(index)"
            >
              <div class="pad-1">
                <img
                  :src="require(`@/assets/img/case/${item.img}.jpg`)"
                  class="h-6"
                />
                <div class="fsize-1d3 mrg-v-1">
                  <b>{{ item.user }}</b>
                </div>
                <div>{{ item.pro_name }}</div>
              </div>
              <div
                :class="
                  `trans-fast abs max bg-color-lgray t-0 l-0 ${
                    item.show ? 'alpha-d9' : 'alpha-0'
                  }`
                "
              >
                <article
                  class="color-dark abs max fsize-1d1 pleft pad-2 auto-scroll"
                >
                  {{ item.desc }}
                </article>
                <a
                  href="javascript:;"
                  @click="$_hide_detail(index, $event)"
                  class="abs t-5px r-5px"
                >
                  <span class="flex-5 color-light bg-color-mgray round w-2 h-2">
                    <i class="ico-fail"></i>
                  </span>
                </a>
              </div>
            </b-hot>
          </b-grid>
        </div>
      </div>
    </section>

    <!--其它用户-->
    <section class="bg-color-lgray">
      <div class="container pad-b-4 pad-t-5 pcenter pad-h-2 pad-h-1-s">
        <h2 class="mrg-b-3">
          <span class="fsize-1d5 fsize-1d3-s">其它用户</span>
        </h2>
        <b-grid :col-data="other_cases">
          <a v-for="item of other_cases.items" :slot="item.id">
            <div class="pad-d5">
              <img
                :src="require(`@/assets/img/case/${item.img}.jpg`)"
                class="round-sm"
              />
              <div class="fsize-1d2 mrg-b-2 mrg-t-d5 fsize-1-s">
                <b>{{ item.user }}</b>
              </div>
            </div>
          </a>
        </b-grid>
        <article
          class="container fsize-1d3 pad-t-2 pjustify fsize-1d2-s pad-h-1-s"
          md
        >
          <p>
            基于上述的大数据产业和研究应用基础，作为清华大学唯一推荐入选项目，基于DaaS系统的“互联网感知大数据驱动的民生民情智能应用服务”获工信部2020年大数据产业发展试点示范项目。
          </p>
          <p>
            DaaS以其丰富、宏观、公开、全域、多维度的特性，也非常适合作为高校相关大数据应用课程实践或研究的数据集。例如清华大学的
            <a
              href="https://mp.weixin.qq.com/s/M7B39ejaEDS_9WXSa44fOQ"
              class="color-blue line-b thick-1"
              target="_blank"
              >《大数据处理及分析研究实践III》SRT（大学生研究训练）项目</a
            >，以及正在策划中的相关MOOC课程。
          </p>
          <p>
            DaaS
            AI数据库可为高校和智库的专家、研究者提供数据服务，一方面，DaaS项目组公开向社会披露部分系统设计原型及核心算法；另一方面，DaaS
            AI数据库为学术研究提供丰富的数据来源。
          </p>
        </article>
      </div>
    </section>

    <!--相关文章-->
    <section
      id="article"
      class="rel"
      :style="
        `background-image: url(${require('@/assets/img/backgrounds/img-37.jpg')})`
      "
    >
      <div class="abs max bg-color-dark alpha-d8"></div>
      <div class="rel z1 container grid pad-b-4 color-lgray">
        <div class="col-8 col-12-s pad-t-5 pad-h-2">
          <h4 class="mrg-b-3 line-l line-red pad-l-1d5">
            <span class="fsize-1d4">媒体报道</span>
          </h4>
          <ul class="fsize-1d1 fsize-1d2-s">
            <list-item-widget
              v-for="(report, index) of articles.report"
              :key="index"
              :item-title="report.title"
              :item-link="report.link"
            />
          </ul>
        </div>
        <div class="col-4 col-12-s pad-t-5 pad-h-2">
          <h4 class="mrg-b-3 line-l line-red pad-l-1d5">
            <span class="fsize-1d4">DaaS 自媒体</span>
          </h4>
          <ul class="grid">
            <li
              :class="`col-6 ${index % 2 ? 'pad-l-d5' : 'pad-r-d5'}`"
              v-for="(report, index) of articles.daas"
              :key="index"
            >
              <list-img-item-widget
                :item-img="report.img"
                :item-link="report.link"
              />
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!--footer-->
    <footer id="footer" class="bg-color-dgray">
      <div class="pad-v-1 alpha-d4 pcenter color-lgray">
        蜀ICP备18029429号-1
      </div>
    </footer>

    <!--下载链接-->
    <a ref="downloadAnchor"></a>
  </div>
</template>

<script>
import BGrid from "@/components/BTXUI/core/b-grid";
import BHot from "@/components/BTXUI/core/b-hot";
import BtnWidget from "@/components/BTXUI/btn/btn-widget";
import PannelWidget from "@/components/BTXUI/pannel/pannel-widget";
import FormPannelWidget from "@/components/BTXUI/formPannel/form-pannel-widget";
import TableWidget from "@/components/BTXUI/table/table-widget";
import TabWidget from "@/components/BTXUI/tab/tab-widget";
import ListItemWidget from "@/components/list-item-widget";
import ListImgItemWidget from "@/components/list-img-item-widget";
import ResponseNavWidget from "@/components/zk2861/response-nav-widget";

export default {
  name: "Index",
  components: {
    BGrid,
    BtnWidget,
    BHot,
    PannelWidget,
    FormPannelWidget,
    TableWidget,
    ListItemWidget,
    ListImgItemWidget,
    ResponseNavWidget,
    TabWidget
  },
  data() {
    return {
      currentTableInfo: {
        taoqi: {
          name: "选择您关注的地区和行业，将得到以下信息：",
          title: "淘企-“有哪些企业？”",
          desc:
            "本地各个行业和产业都有哪些企业？分布在哪里，以及它们的基本信息。企业列表和基本信息实时更新",
          content: [
            "当地该行业的企业列表；",
            "各企业的风险测算；",
            "企业基本信息；",
            "数据基础包含全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新。"
          ]
        },
        merchant: {
          name:
            "输入任意地区和企业名，您将得到在当地引进该企业的招商价值分析：",
          title: "招商计算器 -“值不值得招”",
          desc:
            "一个企业对某地的招商价值，带给当地的就业、利润、营收、税收、土地增值空间、对当地环保隐患、社会稳定隐患、和法律诉讼隐患的评估，一键生成",
          content: [
            "带给当地的就业、利润、营收、税收；",
            "带给当地的土地增值空间；",
            "对当地环保隐患、社会稳定隐患、和法律诉讼隐患的评估；",
            "数据基础包含全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新。"
          ]
        },
        chain: {
          name: "选择您关注的地区和产业链节点，您会获得：",
          title: "产业链分析-“产业链短板及前景”",
          desc:
            "本地产业链的短板、前景分析，与全国各强地区的对标和互补的节点分析",
          content: [
            "本地产业链的短板、前景分析；",
            "与全国各强地区的对标和互补的节点分析；",
            "数据基础包含全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新。"
          ]
        },
        finance: {
          name: "选择您关注的地区，您将得到：",
          title: "财政税收风险预警：-“本地行业财税风险”",
          desc: "提前两个季度对本地82个行业的营收、利润、税收情况进行预警",
          content: [
            "该地区83个行业的营收、利润、税收的实时风险分析；",
            "提前两个季度对本地82个行业的营收、利润、税收情况进行预警；",
            "数据基础包含全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新。"
          ]
        },
        advantage: {
          name: "选择您关注的地区，您将得到：",
          title: "本地产业分析-“发现亮点与不足”",
          desc:
            "本地经济产业方面，跟全国区市县对比，从经济规模、结构和发展潜力方面进行评估和对标，每月报告，每月更新",
          content: [
            "本地经济产业方面，与全国区市县对比；",
            "从经济规模、结构和发展潜力方面进行评估和对标；3. 数据基础包含全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新。"
          ]
        },
        industry: {
          name: "选择您关注的地区，您将得到：",
          title: "本地创新产业分析-“产业现状及趋势”",
          desc:
            "本地创新产业发展及区域对标，重点包括：信息技术、智能制造、大健康和节能环保，每月分析报告，每月更新",
          content: [
            "本地创新产业发展及区域对标分析报告，重点包括：信息技术、智能制造、大健康和节能环保；",
            "数据基础包含全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新。"
          ]
        }
      },
      price_dialog_content: [
        [
          "招商计算器",
          "-“值不值得招”",
          "一个企业对某地的招商价值，带给当地的就业、利润、营收、税收、土地增值空间、对当地环保隐患、社会稳定隐患、和法律诉讼隐患的评估，一键生成",
          "支持全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新",
          "联系客服经理/",
          "支持定制",
          "MERCHANT",
          "需申请序列号"
        ],
        [
          "财政税收风险预警",
          "-“本地行业财税风险”",
          "提前两个季度对本地82个行业的营收、 利润、税收情况进行预警",
          "支持全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新",
          "联系客服经理/",
          "支持定制",
          "FINANCE",
          "需申请序列号"
        ],
        [
          "本地产业分析",
          "-“发现亮点与不足”",
          "本地经济产业方面，跟全国区市县对比，从经济规模、结构和发展潜力方面进行评估和对标，每月报告，每月更新",
          "支持全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新",
          "联系客服经理/",
          "支持定制",
          "ADVANTAGE",
          "需申请序列号"
        ],
        [
          "本地创新产业分析",
          "-“产业现状及趋势”",
          "本地创新产业发展及区域对标，重点包括：信息技术、智能制造、大健康和节能环保，每月分析报告，每月更新",
          "支持全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新",
          "联系客服经理/",
          "支持定制",
          "INDUSTRY",
          "需申请序列号"
        ],
        [
          "产业链分析",
          "-“产业链短板及前景”",
          "本地产业链的短板、前景分析，与全国 各强地区的对标和互补的节点分析",
          "支持全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新",
          "联系客服经理/",
          "支持定制",
          "CHAIN",
          "需申请序列号"
        ],
        [
          "淘企",
          "-“有哪些企业”",
          "本地各个行业和产业都有哪些企业？分布在哪里，以及它们的基本信息。企业列表和基本信息实时更新",
          "支持全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新",
          "联系客服经理/",
          "支持定制",
          "TAOQI",
          "需申请序列号"
        ],
        [
          "产业招商数据大脑",
          "",
          "若干个关于产业发展、本地招商、行业财税预警的小工具合集",
          "支持全部7600万家企业，支持全部2861个区县和全部337个城市，每周更新",
          "联系客服经理/",
          "支持定制",
          "BRAINS",
          "手机注册/申请序列号"
        ]
      ],
      //导航
      main_nav: {
        logo: require("@/assets/img/logo/logo.png"),
        navs: [
          {
            text: "DaaS 实时数据库",
            link: {
              chapter_id: "main",
              chapter_link_data: {
                offset: -60
              }
            }
          },
          {
            text: "DaaS 数据包介绍",
            link: {
              chapter_id: "aboutDaas",
              chapter_link_data: {
                offset: -60
              }
            }
          },
          {
            text: "基于 DaaS 的应用",
            link: {
              chapter_id: "daasCase",
              chapter_link_data: {
                offset: -60
              }
            }
          },
          {
            text: "产品下载",
            link: {
              chapter_id: "pros",
              chapter_link_data: {
                offset: -60
              }
            }
          },
          {
            text: "应用案例",
            link: {
              chapter_id: "cases",
              chapter_link_data: {
                offset: -60
              }
            }
          },
          {
            text: "媒体报道",
            link: {
              chapter_id: "article",
              chapter_link_data: {
                offset: -60
              }
            }
          },
          {
            text: "关于我们",
            link: "https://2861.wiki/1017/riit.html"
            // link: "https://www.riit.tsinghua.edu.cn/info/1017/4946.htm"
          }
        ]
      },

      //软件信息
      softwears: {
        //高质量发展指数
        hqd: {
          title: "高质量发展指数",
          uname: "hqd",
          pwd: "hqd123456",
          link: "http://www.2861.wiki/2861HQD/HQDAppCenter.zip"
        },

        //城市体检
        cty: {
          title: "城市体检",
          uname: "cty",
          pwd: "cty123456",
          link: "http://www.2861.wiki/CtyAppCenter/CtyAppCenter.zip"
        },

        //新矛盾指数
        download: {
          title: "新矛盾指数",
          uname: "download",
          pwd: "zk123456",
          link: "http://www.2861.wiki/download/zhiku2861.zip"
        },

        //国家治理现代化
        mong: {
          title: "国家治理现代化",
          uname: "mong",
          pwd: "qh1911",
          link: "http://www.2861.wiki/mong/zk2861_qh.zip"
        },

        //商业地产精算
        real_estate: {
          title: "商业地产精算",
          uname: "real_estate",
          pwd: "re123456",
          link: "http://www.2861.wiki/2861RealEstate/2861RealEstate.zip"
        }
      },

      //当前预备下载软件
      cur_softwear: null,

      //下载表单
      download_form: {
        form_data: {
          formData: [
            {
              input_data: {
                type: "text",
                name: "uname",
                placeholder: "请输入用户名"
              },
              text: "用户名"
            },
            {
              input_data: {
                type: "password",
                name: "pwd",
                placeholder: "请输入密码"
              },
              text: "密码"
            }
          ],
          layout: {
            title_width: 6
          },
          submit: {
            btn_data: {
              btnText: "下载",
              btnWidth: 10,
              btnRound: true
            },
            align: "center",
            callback: this.$_download_check
          }
        },
        pannel_title: "",
        pannel_info: {
          visible: false,
          selected: {}
        },
        pannel_data: {
          closeBtn: true
        }
      },

      //付费用户
      cases: {
        common_plan: "col-3 col-6-s",
        items: [
          {
            id: "fgw",
            img: "fgw",
            user: "国家发改委",
            pro_name: "中国宏观经济指标人工智能大数据监测分析方法研究",
            desc:
              "重点研发监测我国GDP动态增速，通过自动化的数据驱动方式对我国以GDP增速为核心的宏观经济指标开展高频度监测分析，重点解决统计数据相对滞后和重大事件经济冲击实时预警等问题，为基于大数据的宏观经济形势分析提供辅助服务。",
            show: false
          },
          {
            id: "qh_manager",
            img: "qh_manager",
            user: "清华大学公共管理学院",
            pro_name: "中国区域高质量发展评测大数据技术服务",
            desc:
              "研究全国、省区、地市和县域四级高质量发展评测指标体系、高质量发展评测指数等内容。",
            show: false
          },
          {
            id: "qh_city",
            img: "qh_city",
            user: "清华大学中国城市研究院",
            pro_name: "第三方城市体检",
            desc:
              "项目由国家住房和城乡建设部主导，在推动城市高质量发展与治理能力现代化背景下，将城市体检作为城市治理创新型手段，对全国性和常态化城市进行体检。",
            show: false
          },
          {
            id: "qh_th",
            img: "qh_th",
            user: "北京清华同衡规划设计研究院",
            pro_name: "区域总规",
            desc: "",
            show: false
          },
          {
            id: "njzky",
            img: "njzky",
            user: "南京中科院地理与湖泊研究所",
            pro_name: "",
            desc: "",
            show: false
          },
          {
            id: "qh_th2",
            img: "qh_th",
            user: "清华同衡城士科技",
            pro_name: "分区分级精准掌握防疫期间复工复产情况",
            desc:
              "为发挥特殊时期智库作用，助力政府部门多维度掌握分区分级精准复工复产情况，优化疫情防控措施，使用DaaS 实时AI大数据技术试算新冠病毒防疫期间的全国商业办公区域人口活跃度指标和劳务输出区县务工人员离乡返工率，供各方面研究参考。",
            show: false
          },
          {
            id: "zsdx",
            img: "zsdx",
            user: "中山大学地理科学与规划学院",
            pro_name: "区县建设和规划",
            desc: "",
            show: false
          },
          {
            id: "qh",
            img: "qh",
            user: "清华大学",
            pro_name: "借助AI大数据技术以教育舆情为基础提升决策类信息报送",
            desc:
              "探索在公共管理服务领域，借助AI大数据平台，形成有实时数据支撑，AI自动成文，提供具有辅助决策性的高质量信息。",
            show: false
          },
          {
            id: "qh_fs",
            img: "qh_fs",
            user: "清华大学佛山先进制造研究院",
            pro_name: "基于AI大数据的佛山高质量发展指数研究",
            desc:
              "开展基于AI大数据的佛山高质量发展指数研究，实现高质量发展指数的全面、实时、动态监控与展示，把事后响应转变为事前预测，早发现、早应对，有效提供辅助决策，实现真正的数据驱动区域社会治理变革，提升区域治理能力。",
            show: false
          },
          {
            id: "bjgs",
            img: "bjgs",
            user: "北京工商大学",
            pro_name: "农地“三权分置”的信托模式研究",
            desc:
              "国家社科基金资助项目，基于大数据采集和分析方法，解析福建沙县、浙江绍兴等开展农村土地流转信托的地区主要经济指标变化，提炼各功能区发展特征、发展差异和关键短板指标等。",
            show: false
          },
          {
            id: "bjgs2",
            img: "bjgs",
            user: "北京工商大学",
            pro_name:
              "河南等10省（区、市）农业综合行政执法示范县、示范单位创建评审",
            desc:
              "采用大数据对河南等10省50余市县就重大农产品治理安全事件或违法行为进行不稳定事件的历史监测。",
            show: false
          }
        ]
      },

      //其它用户
      other_cases: {
        common_plan: "col-2d4 col-4-s",
        items: [
          {
            id: "sas",
            img: "sas",
            user: "SaS总部"
          },
          {
            id: "fzyjzx",
            img: "fzyjzx",
            user: "国务院发展研究中心"
          },
          {
            id: "ali",
            img: "ali",
            user: "阿里巴巴城市大脑"
          },
          {
            id: "rdcy",
            img: "rdcy",
            user: "人大重阳"
          },
          {
            id: "zgxws",
            img: "zgxws",
            user: "中国新闻社"
          },
          {
            id: "tkrs",
            img: "tkrs",
            user: "招商证券泰康人寿某基金"
          },
          {
            id: "cqgh",
            img: "cqgh",
            user: "重庆规划设计院"
          },
          {
            id: "mj",
            img: "mj",
            user: "每日经济新闻"
          },
          {
            id: "mj_xw",
            img: "mj_xw",
            user: "旗下每经智库"
          },
          {
            id: "jll",
            img: "jll",
            user: "仲量联行（JLL）"
          },
          {
            id: "fzdx",
            img: "fzdx",
            user: "福州大学建筑学院"
          },
          {
            id: "xhs",
            img: "xhs",
            user: "新华社卫星新闻实验室"
          },
          {
            id: "qh_hxyjy",
            img: "qh_hxyjy",
            user: "清华大学海峡研究院"
          },
          {
            id: "xncj",
            img: "xncj",
            user: "西南财经大学"
          },
          {
            id: "qh_gjzlyjy",
            img: "qh_gjzlyjy",
            user: "清华大学国家治理研究院"
          }
        ]
      },

      //相关文章
      articles: {
        report: [
          {
            title: "长三角六维量化全面发展指数分析报告（2020年7月）",
            link: "https://www.toutiao.com/i6864829616985637390/"
          },
          {
            title: "DaaS AI数据库：探索第三方城市体检大数据关键技术",
            link: "https://www.toutiao.com/i6838104302058209795/"
          },
          {
            title: "DaaS AI数据库 信研院科技创新成果支持疫情防控（三）",
            link: "http://riit.tsinghua.edu.cn/info/xwmt_dtxw/33362"
          },
          {
            title: "清小C番外特别篇: 互联网感知大数据驱动的智能应用",
            link: "https://mp.weixin.qq.com/s/kM7Zz-JYfDquYKtG3KQ1qA"
          },
          {
            title:
              "中国城市土地利用制图委员会第四次会议召开：众智共度现时艰，协力同测千城变",
            link:
              "http://www.cess.tsinghua.edu.cn/publish/ess/7777/2020/20200611131828703823347/20200611131828703823347_.html"
          },
          {
            title:
              "如何分区分级精准掌握防疫期间复工复产情况——基于AI大数据技术的监测和研究",
            link: "https://m.sohu.com/a/377255494_120051682"
          },
          {
            title: "“第三只眼”看上海 卫星遥感图显示工业和商业快速“回暖”",
            link:
              "http://k.sina.com.cn/article_1737737970_6793c6f202000uyiw.html?from=news&subch=onews&sudaref=www.baidu.com&display=0&retcode=0"
          },
          {
            title: "全国商业活跃度恢复近7成，中小城市恢复更快（自：第一财经）",
            link:
              "https://m.yicai.com/news/100546059.html?from=timeline&isappinstalled=0"
          },
          {
            title:
              "Xinhua Headlines: Economic activities regaining vitality in world's largest market（自：新华网）",
            link:
              "http://www.xinhuanet.com/english/2020-04/12/c_138969360.htm?from=groupmessage&isappinstalled=0"
          },
          {
            title: "卫星图“秀”出长三角新“夜”态（自：新民晚报）",
            link:
              "https://wap.xinmin.cn/content/31741363.html?from=singlemessage&isappinstalled=0"
          },
          {
            title: "“新五朵金花”-成华小学，70万起就能买成都市成华区学区房",
            link: "https://www.toutiao.com/i6828746369323237899/"
          },
          {
            title: "扎根成都，首付预算50-80万，哪里性价比最高？",
            link: "https://www.toutiao.com/i6828746232140136963/"
          }
        ],
        daas: [
          {
            img: "tt.png",
            link:
              "https://www.toutiao.com/c/user/2436131759602440/#mid=1660402093052940"
          },
          {
            img: "dc.png",
            link:
              "https://www.toutiao.com/c/user/3755567576791566/#mid=1665999990346766"
          }
        ]
      },

      //daas 实时数据
      daas_data: {
        tab_data: {
          tagsData: {
            tagList: [],
            colors: {
              normal: {
                text: "mgray",
                bg: "dgray"
              },
              hover: {
                text: "main",
                bg: "sub"
              },
              act: {
                text: "light",
                bg: "sub"
              }
            }
          }
        },
        cur_tab: "a_0",
        content: {
          def: {
            type: "intro",
            data: [
              {
                id: "popu",
                text: "实时人口数据包"
              },
              {
                id: "cty",
                text: "城市体检数据包"
              },
              {
                id: "opn",
                text: "地区事件和民众口碑数据包"
              },
              {
                id: "cbd",
                text: "商圈画像数据包"
              },
              {
                id: "space",
                text: "区域空间改造评估数据包"
              },
              {
                id: "visual",
                text: "区县决策辅助数据可视化系统"
              }
            ]
          }
        }
      },

      //文档信息
      doc: {
        visible: false,
        title: "",
        desc: "",
        cont: {
          type: "",
          info: ""
        },
        pannel_data: {
          closeBtn: true,
          maxEnable: {
            width: "100%",
            height: "100%",
            bg: "#061b2c"
          },
          matteZIndex: 10
        }
      },
      showPriceDialog: false
    };
  },
  computed: {
    //下载锚点
    download_anchor() {
      return this.$refs.downloadAnchor;
    },

    //文档
    doc_cont() {
      return this.$refs.docCont;
    },
    isWin() {
      return navigator.platform == "Win32" || navigator.platform == "Windows";
    },
    mainStyle() {
      return {
        overflow: this.showPriceDialog ? "hidden" : "auto"
      };
    }
  },
  methods: {
    //开启软件下载弹窗
    $_show_download_pannel(pid) {
      this.cur_softwear = this.softwears[pid];
      this.download_form.pannel_title = `${this.cur_softwear.title}软件`;
      this.download_form.pannel_info.visible = !this.download_form.pannel_info
        .visible;
    },

    //下载验证
    $_download_check(form_data) {
      let { uname, pwd, link } = this.cur_softwear;
      if (uname === form_data.uname) {
        if (pwd === form_data.pwd) {
          this.$_download(link, uname);
        } else {
          this.$confirm.alert("密码有误!", "fail");
        }
      } else {
        this.$confirm.alert("账号有误!", "fail");
      }
    },

    //执行下载
    $_download(link, pro_name) {
      let anchor = this.download_anchor;
      anchor.setAttribute("href", link);
      anchor.setAttribute("download", `${pro_name}.zip`);
      anchor.click();
      this.download_form.pannel_info.visible = false;
    },

    //下载主产品
    $_download_zk2861_pro() {
      this.showPriceDialog = true;
      // this.$confirm.confirm("确认下载 DaaS 数据库产品？", () => {
      //   let anchor = this.download_anchor;
      //   anchor.setAttribute(
      //     "href",
      //     "http://www.2861.wiki/ZhiKu2861/zk2861.zip"
      //   );
      //   anchor.setAttribute("download", "zk2861.zip");
      //   anchor.click();
      // });
    },

    //显示付费客户细节信息
    $_show_detail(index) {
      this.cases.items[index].show = true;
    },

    //隐藏付费客户细节信息
    $_hide_detail(index, e) {
      e && e.stopPropagation();
      this.cases.items[index].show = false;
    },

    //获取 daas 实时数据库数据
    $_init_daas_data() {
      this.$axios
        .post("https://db_center.2861.wiki/download_center/api/package/list/v1")
        .then(res => {
          let data = res.data;
          if (data.code == "200") {
            let content = this.daas_data.content,
              tag_list = this.daas_data.tab_data.tagsData.tagList;
            data.data.forEach((item, index) => {
              let id = `a_${index}`;
              content[id] = this.$_gen_table_data(item.list);
              if (index === 0) {
                content[id].tbody.push([
                  "城市体检产品介绍",
                  {
                    btn_data: {
                      btnText: "查看文档",
                      btnColor: {
                        normal: {
                          text: "light",
                          bg: "neutral",
                          line: "none"
                        },
                        hover: {
                          text: "sub",
                          bg: "neutral",
                          line: "none"
                        }
                      }
                    },
                    callback: () => {
                      window.open(
                        "https://www.2861.wiki/html_docs/2861-city.html"
                      );
                    }
                  }
                ]);
              }
              tag_list.push({
                id,
                text: item.name
              });
            });
            tag_list.push({
              id: "def",
              text: "数据包概览"
            });
          } else {
            this.$confirm.alert(data.info, "fail");
          }
        });
    },

    //构造表格数据
    $_gen_table_data(data) {
      return {
        thead: [
          {
            title: "数据包名称",
            grow: 3
          },
          {
            title: "",
            grow: 1
          }
        ],
        tbody: data.rows.map(item => {
          return [
            item[1].text,
            {
              btn_data: {
                btnText: "查看文档",
                btnColor: {
                  normal: {
                    text: "light",
                    bg: "neutral",
                    line: "none"
                  },
                  hover: {
                    text: "sub",
                    bg: "neutral",
                    line: "none"
                  }
                }
              },
              callback: () => {
                this.$_broswer_doc(item[0].id.split("-").pop());
              }
            }
          ];
        }),
        colors: {
          thead: "sub",
          row: {
            head: "none",
            odd: "neutral",
            even: "#061b2c"
          },
          line: "none",
          outline: "none"
        }
      };
    },

    //浏览文档
    $_broswer_doc(id) {
      let formdata = new FormData();
      formdata.append("pkg_id", id);
      this.$axios({
        method: "post",
        url:
          "https://db_center.2861.wiki/download_center/api/package/dataset/v1",
        data: formdata
      }).then(res => {
        let data = res.data;
        if (data.code == "200") {
          let dataset = data.data.dataset_list;
          this.doc.visible = true;
          this.doc.title = data.data.pkg_name;
          this.doc.desc = data.data.desc_text;
          if (data.data.show_list) {
            this.doc.cont.type = "table";
            this.doc.cont.info = {
              thead: dataset.cols.map((item, index) => {
                return index === 0
                  ? {
                      title: item.text,
                      grow: 3
                    }
                  : { title: item.text };
              }),
              tbody: dataset.rows.map(item => {
                return item.map(sub => {
                  return sub.text;
                });
              }),
              colors: {
                thead: "#111",
                row: {
                  head: "none",
                  odd: "#333",
                  even: "#444"
                },
                line: "none",
                outline: "#111"
              }
            };
          } else {
            this.doc.cont.type = "";
          }
          this.doc_cont.focus();
          this.doc_cont.scrollTop = 0;
        } else {
          this.$confirm.alert(data.info, "fail");
        }
      });
    },

    //退出文档浏览
    $_exit_doc() {
      this.doc.visible = false;
    },
    openZip() {
      window.open("https://www.51dongshi.com/ebzdsserchs.html");
    }
  },
  beforeMount() {
    document.title = "DaaS实时数据库";
  },
  mounted() {
    this.$_init_daas_data();
  }
};
</script>
<style scoped>
.price-dialog-wrap {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.699);
}
.price-dialog-wrap .content {
  height: 75%;
  width: 1200px;
  background: #ffffff;
}
.price-dialog-wrap header {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e7e7e7;
}
.price-dialog-wrap header h2 {
  font-size: 26px;
  font-weight: bold;
  padding-left: 45px;
  color: #2c2c2c;
}
.price-dialog-wrap header .close {
  display: inline-block;
  padding-right: 45px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  background: url("../assets/img/daas_case/close.png") no-repeat;
}
.price-dialog-wrap .table-wrap {
  height: calc(100% - 100px);
  padding: 0 45px;
  padding-top: 40px;
}
.price-dialog-wrap .table-wrap .table-inner-wrap {
  height: 100%;
  border: 1px solid #d6d6d6;
  border-radius: 7px 7px 0px 0px;
}
.table-wrap {
  position: relative;
}
.table-wrap .open-style {
  position: absolute;
  right: 45px;
  top: 10px;
  font-weight: bold;
  color: #fe0c2e !important;
  line-height: 18px !important;
  display: inline-block !important;
  font-size: 16px !important;
  text-decoration: underline;
  cursor: pointer;
}
.table-wrap .sys-tip {
  position: absolute;
  right: 500px;
  top: 10px;
  /* font-weight: bold; */
  color: #fe0c2e !important;
  line-height: 18px !important;
  display: inline-block !important;
  font-size: 16px !important;
  /* text-decoration: underline;
  cursor: pointer; */
}
.table-inner-wrap .table-head {
  display: flex;
  align-items: center;
  height: 75px;
  border-bottom: 1px solid #d6d6d6;
}
.table-inner-wrap .table-head span {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}
.table-inner-wrap .table-head span:nth-child(1) {
  flex: 222;
  text-align: left;
  /* padding-left: 19px; */
}
.table-inner-wrap .table-head span:nth-child(2) {
  text-align: left;
  flex: 342;
}
.table-inner-wrap .table-head span:nth-child(3) {
  flex: 246;
  text-align: left;
}
.table-inner-wrap .table-head span:nth-child(4) {
  flex: 142;
  text-align: left;
}
.table-inner-wrap .table-head span:nth-child(5) {
  text-align: left;
  flex: 158;
}
/* ************************** */
.table-content {
  height: calc(100% - 75px);
  overflow-y: auto;
  overflow-x: hidden;
}
.table-content .table-row {
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #d6d6d6;
  padding: 22px 0;
}
.table-content .table-row:nth-child(2n) {
  background: #eef3fa;
}
.table-content .table-row:nth-child(2n + 1) {
}
.table-content .table-row .cell {
  /* flex: 222; */
}
.table-content .table-row .cell:nth-child(1) {
  padding-left: 19px;
  flex: 222;
}
.table-content .table-row .cell:nth-child(2) {
  flex: 342;
  padding-right: 40px;
}
.table-content .table-row .cell:nth-child(3) {
  flex: 246;
  padding-right: 40px;
}
.table-content .table-row .cell:nth-child(4) {
  flex: 142;
}
.table-content .table-row .cell:nth-child(5) {
  flex: 158;
}
.table-content .table-row span {
  font-size: 16px;
  font-weight: 500;
  color: #2c2c2c;
}
.table-content .table-row .download {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.table-content .table-row .download a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 30px;
  background: #fe0c2e;
  border-radius: 2px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}
.table-content .table-row .download span {
  font-size: 14px;
}
.table-content .table-row .download a:hover {
  background: #d00a26;
}
</style>
<style lang="less" scoped>
.table-outter {
  width: 1100px;
  position: relative;
  header {
    background: #ffffff;
    text-align: center;
    justify-content: center;
    h2 {
    }
  }
  .close {
    position: absolute;
    right: 10px;
    top: 23px;
    display: inline-block;
    width: 20px;
    height: 20px;
    cursor: pointer;
    background: url("../assets/img/daas_case/close.png") no-repeat;
  }
}
.table-info {
  background: #ffffff;
  border: 1px solid #d6d6d6;

  display: flex;
  flex: 1;
  .table-inner {
    flex: 1;
    ul {
      li {
        display: flex;
        height: 95px;
        align-items: center;

        &:nth-child(2n + 1) {
          background: #eef3fa;
        }
        p {
          // display: flex;
          // flex-direction: column;
          width: 240px;
          padding-left: 19px;
          line-height: 22px;
          // display: flex;
          // align-items: center;
          span {
            font-size: 18px;
            font-weight: 500;
            color: #2c2c2c;
            line-height: 20px;
          }
        }
        span {
          flex: 1;
          height: 55px;
          font-size: 16px;
          font-weight: 500;
          color: #2c2c2c;
          line-height: 20px;
        }
        .aspan {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .table-detail {
    width: 210px;
    padding: 0 20px;
    p {
      font-size: 16px;
      font-weight: 500;
      color: #2c2c2c;
      line-height: 20px;
      margin: 0;
      &:nth-child(1) {
        padding-top: 126px;
      }
      &:nth-child(2) {
        padding-top: 20px;
        padding-bottom: 20px;
      }
      &:nth-child(4) {
        padding-top: 1px;
        padding-bottom: 20px;
      }
    }
    .zip {
      font-size: 16px;
      font-weight: 500;
      color: #fe0c2e;
      line-height: 22px;
      display: inline-block;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/router/index.vue